import React, { useEffect, useState } from "react";
import axios from 'axios';

const CitiusButton = () => {
    const [inbounds, setInbounds] = useState(false);

    useEffect(() => {
        axios.get('https://citius.gal/inbounds')
        .then(response => {
            setInbounds(true);
        })
        .catch(error => {
            setInbounds(false);
        });

        if(inbounds){
            const script = document.createElement('script');
    
            script.src = "https://citius.gal/bottomicon-citius/bottomicon-citius.js";
            script.async = true;
    
            document.body.appendChild(script);
    
            return () => {
                document.body.removeChild(script);
            }
        }
    }, [inbounds]);
    
    return <></>;
};

export default CitiusButton;
